import { FunctionComponent } from "react"
import SidebarClosed from "./sidebar-closed"
import SidebarOpen from "./sidebar-open"
import { useTypedSelector } from "../../../app/store"

const Sidebar: FunctionComponent = () => {
  const { isOpen } = useTypedSelector((state) => state.sidebar)

  return (
    <div>
      {isOpen ? <SidebarOpen /> : <SidebarClosed />}
    </div>
  )
}

export default Sidebar
